import { useOperationsContext } from '../../workspace/operationsContext'
import { ErrorCount } from '../errorCount/ErrorCount'

export const LocationErrorsCount = () => {
  const {
    errors,
    branchKey,
    workspaceKey,
    branchValidationErrors,
    workspaceValidationErrors,
  } = useOperationsContext()

  if (!branchKey) {
    return null
  }

  const workspaceServerValidationCount = workspaceValidationErrors.size
  const branchServerValidationCount = branchValidationErrors.size
  const locationErrorCount = errors?.length ?? 0
  const branchValidationErrorCount =
    branchServerValidationCount + locationErrorCount
  const workspaceValidationErrorCount =
    (workspaceKey ? workspaceServerValidationCount : 0) + locationErrorCount

  const totalErrors = workspaceKey
    ? workspaceValidationErrorCount
    : branchValidationErrorCount

  return <ErrorCount count={totalErrors} />
}
